module.exports = __webpack_public_path__ + "media/images/landings/promotion_3/img_flow-01-3679eed637970192c4fb68b1d9b95a72.png";